import { DonutChart } from '../common/DonutChart';
import pt from '../../locales/pt';

export const HORIZON_HEX = {
  immediate: '#7C9E6F',  // $horizon-1
  days_1_2:  '#5E9E96',  // $horizon-2
  days_2_5:  '#6B8FA8',  // $horizon-3
  weeks:     '#C7986C',  // $horizon-4
  months:    '#B27676',  // $horizon-5
  years_plus:'#A8A29E',  // $horizon-6
};

/** Converts horizonBuckets from buildAccountsPageModel to DonutChart slices. */
export function horizonBucketsToChartData(horizonBuckets = []) {
  return horizonBuckets.map((b) => ({
    id: b.id,
    name: b.label || pt.accounts.liquidity.horizons[b.id] || b.id,
    value: b.totalEur,
    color: HORIZON_HEX[b.id] ?? '#A8A29E',
  }));
}

/**
 * `.pen` → `ds/chart/donut · liquidez` — **é a configuração por defeito do
 * master** (`upD8x`, `L3pEwD`, `M73g6`, `hDw7I`, sem `descendants`): head com
 * título + subtítulo, legenda sem papel, rodapé de 2 métricas, sem centro.
 *
 * `orientation` mapeia o único override que as instâncias reais fazem — o
 * `body` passa a `layout:horizontal` quando o contentor tem ≥ 460px:
 *  - `"auto"` (Início, coluna estreita): empilha, lado a lado em `md`, volta a
 *    empilhar em `lg` (a instância `O4IwLr` a 1280 tem só 304px e é vertical).
 *  - `"row"` (Ativos): lado a lado a partir de `md` sem reverter.
 */
export function LiquidityHorizonDonut({ horizonBuckets = [], orientation = 'auto' }) {
  const slices = horizonBucketsToChartData(horizonBuckets);
  const copy = pt.accounts.liquidity;

  if (!slices.length) {
    return (
      <DonutChart
        title={copy.horizonLabel}
        subtitle={copy.horizonSubtitle}
        state="empty"
        emptyLabel={copy.noHorizonData}
      />
    );
  }

  const total = slices.reduce((sum, row) => sum + row.value, 0);
  const pctFor = (id) => {
    const row = slices.find((r) => r.id === id);
    return row && total > 0 ? (row.value / total) * 100 : 0;
  };
  const fastPct = Math.round(pctFor('immediate') + pctFor('days_1_2'));
  const slowPct = Math.round(pctFor('years_plus'));

  return (
    <DonutChart
      title={copy.horizonLabel}
      subtitle={copy.horizonSubtitle}
      slices={slices}
      bodyLayout={orientation === 'row' ? 'auto' : 'auto-narrow'}
      foot={[
        { label: copy.horizonFootFastLabel, value: `${fastPct}%` },
        { label: copy.horizonFootSlowLabel, value: `${slowPct}%` },
      ]}
    />
  );
}

export default LiquidityHorizonDonut;
